
<div #scrollUp class="scroll-up d-flex justify-content-center align-items-center" (click)="scrollBtn()">
    <i class="arrow-icon fas fa-arrow-up text-white"></i>
</div>